import React from 'react'
import { Checkbox, CheckboxProps } from 'semantic-ui-react'

import { PermissionGroup } from './PermissionGroup'
import { OnCheck } from './AllPermissions'
import { BlankOption } from './styles'

interface APIKeyPermissionsProps {
  onChange: (data: OnCheck) => void
  isChecked: (resource: string, actions: string[]) => boolean
}

export const APIKeyPermissions: React.FC<APIKeyPermissionsProps> = ({
  onChange,
  isChecked
}) => {
  function handleCheck(
    event: React.FormEvent<HTMLInputElement>,
    data: CheckboxProps
  ) {
    const value = data.value as string
    const checked = data.checked as boolean
    onChange({ value, checked })
  }

  return (
    <PermissionGroup label="API Key:">
      <BlankOption />
      <Checkbox
        onChange={handleCheck}
        checked={isChecked('apiKey', ['Create'])}
        value="apiKey:Create"
        label="Cadastrar"
      />
      <Checkbox
        onChange={handleCheck}
        checked={isChecked('apiKey', ['UpdateIps'])}
        value="apiKey:UpdateIps"
        label="Atualizar"
      />
      <Checkbox
        onChange={handleCheck}
        checked={isChecked('apiKey', ['Delete'])}
        value="apiKey:Delete"
        label="Excluir"
      />
    </PermissionGroup>
  )
}
